export const NO_INDEX_NO_FOLLOW_CONSTANTS = ["/sale/search", "/clearance/search"]
export const NO_INDEX_NO_FOLLOW_MERCHANDISED_CONSTANTS = ["/all"]
